import React, {Component} from "react";
import {RouteComponentProps} from "react-router";
import {logPageView} from "services/analytics";
import LandlordDashboardLayout, {DashboardTab} from "layouts/LandlordDashboard";
import BookingsTable from "../components/BookingsTable";
import {BookingsStatsSection} from "../components/BookingsStatsSection";
import './index.scss'

interface LandlordBookingsPageState {
}

interface LandlordBookingsPageProps extends RouteComponentProps {
}

export default class LandlordBookingsPage extends Component<LandlordBookingsPageProps, LandlordBookingsPageState> {
  state: LandlordBookingsPageState = {
  };

  componentDidMount(): void {
    logPageView(this.props.location.pathname, 'Landlord Bookings');
  }

  render() {
    return <LandlordDashboardLayout id="landlord-bookings-page" currentTab={DashboardTab.Bookings}>
      <section className="title">
        <h1>Landlord Dashboard</h1>
      </section>
      <section className="bookings-stats-section">
        <h2>Bookings</h2>
        <BookingsStatsSection />
      </section>
      <section className="bookings-list-section">
        <h2>Booking List</h2>
        <BookingsTable />
    </section>
    </LandlordDashboardLayout>;
  }
}